import { createCustomEnum } from "./customEnum";

const ResidualsStatusTypes = createCustomEnum({
	PayResiduals: {
		name: "PayResiduals",
		value: 0,
		displayName: "Pay Residuals",
	},
	WithholdResiduals: {
		name: "WithholdResiduals",
		value: 1,
		displayName: "Withhold Residuals",
	},
});

export default ResidualsStatusTypes;
